import { axiosInstance } from "../../utility/apiInstance";

export type TeamStatusFilter = "all" | "active" | "inactive";

export const fetchTeams = async (status: TeamStatusFilter = "all") => {
  const params = new URLSearchParams();
  // active = not deleted, inactive = deleted
  if (status === "active") params.set("isDeleted", "false");
  else if (status === "inactive") params.set("isDeleted", "true");
  const qs = params.toString();
  const res = await axiosInstance.get(`/api/v1/customer-team${qs ? `?${qs}` : ""}`);
  return (res?.data?.data || []).reverse();
};

export const fetchTeamMemberCustomers = async () => {
  const res = await axiosInstance.get("/api/v1/customers-auth/team-member-list");
  return (res?.data?.data || []).filter((c: any) => c.role !== "groundstaff");
};

export const fetchTeam = async (id: string) => {
  const res = await axiosInstance.get(`/api/v1/customer-team/${id}`);
  return res?.data?.data;
};

export const createTeam = (payload: any) =>
  axiosInstance.post("/api/v1/customer-team", payload);

export const updateTeam = (id: string, payload: any) =>
  axiosInstance.put(`/api/v1/customer-team/${id}`, payload);

export const toggleTeamDeleted = (id: string, isDeleted: boolean) =>
  axiosInstance.delete(`/api/v1/customer-team/${id}`, { data: { isDeleted } });